<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div id="business-entity" class="panel panel-default">
    <div class="panel-heading">{{ $t('Business entity') }}</div>
    <div class="panel-body">
      <div id="account-business-settings">
        <template v-if="loading">
          <div class="tw-p-4"><WdsSpinner indeterminate :size="40" /></div>
        </template>
        <template v-else>
          <template v-for="compliance in compliances">
            <CommonBusinessEntityForm
              v-if="
                compliance.name === ComplianceName.COMPANY_COMMON_BUSINESS_ENTITY ||
                compliance.name === ComplianceName.FREELANCER_COMMON_BUSINESS_ENTITY ||
                compliance.name === ComplianceName.RECRUITER_COMMON_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
              :compliance-data="compliance.data"
            />
            <CompanyAuBusinessEntityForm
              v-if="
                AccountType.isCompany(activeAccount.__typename) &&
                compliance.name === ComplianceName.COMPANY_AU_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
            />
            <CompanyCaBusinessEntityForm
              v-if="
                AccountType.isCompany(activeAccount.__typename) &&
                compliance.name === ComplianceName.COMPANY_CA_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
            />
            <CompanyDeBusinessEntityForm
              v-if="
                (AccountType.isCompany(activeAccount.__typename) &&
                  compliance.name === ComplianceName.COMPANY_DE_BUSINESS_ENTITY) ||
                (AccountType.isRecruiter(activeAccount.__typename) &&
                  compliance.name === ComplianceName.RECRUITER_DE_BUSINESS_ENTITY)
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
              :require-company-no="AccountType.isRecruiter(activeAccount.__typename)"
            />
            <CompanySgBusinessEntityForm
              v-if="
                AccountType.isCompany(activeAccount.__typename) &&
                compliance.name === ComplianceName.COMPANY_SG_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
            />
            <CompanyNlBusinessEntityForm
              v-if="
                (AccountType.isCompany(activeAccount.__typename) &&
                  compliance.name === ComplianceName.COMPANY_NL_BUSINESS_ENTITY) ||
                (AccountType.isRecruiter(activeAccount.__typename) &&
                  compliance.name === ComplianceName.RECRUITER_NL_BUSINESS_ENTITY)
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
            />
            <BaseUsBusinessEntityForm
              v-if="
                (AccountType.isCompany(activeAccount.__typename) &&
                  compliance.name === ComplianceName.COMPANY_US_BUSINESS_ENTITY) ||
                (AccountType.isRecruiter(activeAccount.__typename) &&
                  compliance.name === ComplianceName.RECRUITER_US_BUSINESS_ENTITY)
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
            />
            <FreelancerAuBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_AU_BUSINESS_ENTITY
              "
              :key="compliance.name"
              v-model:compliance-data="compliance.data"
              :business-entity="primaryBusinessEntity"
            />
            <FreelancerCaBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_CA_BUSINESS_ENTITY
              "
              :key="compliance.name"
              v-model:compliance-data="compliance.data"
              :business-entity="primaryBusinessEntity"
              :current-selected-location="currentSelectedLocation"
            />
            <FreelancerDeBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_DE_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
              :compliance-data="compliance.data"
              :freelancer="activeAccount"
            />
            <FreelancerDkBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_DK_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
            />
            <FreelancerFrBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_FR_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
              :compliance-data="compliance.data"
              :freelancer="activeAccount"
            />
            <FreelancerIeBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_IE_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
              :compliance-data="compliance.data"
              :freelancer="activeAccount"
            />
            <FreelancerNlBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_NL_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
              :compliance-data="compliance.data"
              :freelancer="activeAccount"
            />
            <FreelancerSgBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_SG_BUSINESS_ENTITY
              "
              :key="compliance.name"
              v-model:compliance-data="compliance.data"
              :business-entity="primaryBusinessEntity"
            />
            <FreelancerUkBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_UK_BUSINESS_ENTITY
              "
              :key="compliance.name"
              :business-entity="primaryBusinessEntity"
              :compliance-data="compliance.data"
              :freelancer="activeAccount"
            />
            <FreelancerUsBusinessEntityForm
              v-if="
                AccountType.isFreelancer(activeAccount.__typename) &&
                compliance.name === ComplianceName.FREELANCER_US_BUSINESS_ENTITY
              "
              :key="compliance.name"
              v-model:compliance-data="compliance.data"
              :business-entity="primaryBusinessEntity"
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import { WdsSpinner } from '@worksome/wds-components'
import BaseUsBusinessEntityForm from '@/components/compliances/BusinessEntity/BaseUsBusinessEntityForm.vue'
import CommonBusinessEntityForm from '@/components/compliances/BusinessEntity/CommonBusinessEntityForm.vue'
import CompanyAuBusinessEntityForm from '@/components/compliances/BusinessEntity/CompanyAuBusinessEntityForm.vue'
import CompanyCaBusinessEntityForm from '@/components/compliances/BusinessEntity/CompanyCaBusinessEntityForm.vue'
import CompanyDeBusinessEntityForm from '@/components/compliances/BusinessEntity/CompanyDeBusinessEntityForm.vue'
import CompanyNlBusinessEntityForm from '@/components/compliances/BusinessEntity/CompanyNlBusinessEntityForm.vue'
import CompanySgBusinessEntityForm from '@/components/compliances/BusinessEntity/CompanySgBusinessEntityForm.vue'
import FreelancerAuBusinessEntityForm from '@/components/compliances/BusinessEntity/FreelancerAuBusinessEntityForm.vue'
import FreelancerCaBusinessEntityForm from '@/components/compliances/BusinessEntity/FreelancerCaBusinessEntityForm.vue'
import FreelancerDeBusinessEntityForm from '@/components/compliances/BusinessEntity/FreelancerDeBusinessEntityForm.vue'
import FreelancerDkBusinessEntityForm from '@/components/compliances/BusinessEntity/FreelancerDkBusinessEntityForm.vue'
import FreelancerFrBusinessEntityForm, {
  fragments as FreelancerFrBusinessEntityFormFragments,
} from '@/components/compliances/BusinessEntity/FreelancerFrBusinessEntityForm.vue'
import FreelancerIeBusinessEntityForm from '@/components/compliances/BusinessEntity/FreelancerIeBusinessEntityForm.vue'
import FreelancerNlBusinessEntityForm from '@/components/compliances/BusinessEntity/FreelancerNlBusinessEntityForm.vue'
import FreelancerSgBusinessEntityForm from '@/components/compliances/BusinessEntity/FreelancerSgBusinessEntityForm.vue'
import FreelancerUkBusinessEntityForm from '@/components/compliances/BusinessEntity/FreelancerUkBusinessEntityForm.vue'
import FreelancerUsBusinessEntityForm from '@/components/compliances/BusinessEntity/FreelancerUsBusinessEntityForm.vue'
import {
  PRIMARY_BUSINESS_ENTITY_ON_ACCOUNT_FRAGMENT,
  COMPLIANCE_RESULT_FRAGMENT,
  ACTIVE_COMPLIANCES_ON_ACCOUNT_FRAGMENT,
} from '@/components/compliances/queries/Compliances'
import {
  businessEntityCompliances,
  ComplianceName,
} from '@/components/compliances/types/ComplianceName.enum'
import businessEntityFromGraphql from '@/components/compliances/utils/graphql/businessEntityFromGraphql'
import applyOldInputToBusinessEntity from '@/components/compliances/utils/applyOldInputToBusinessEntity'
import { fragments as UkBusinessEntityUmbrellaFormFragments } from '@/components/compliances/BusinessEntity/Uk/UkBusinessEntityUmbrellaForm.vue'
import AccountType from '@/utils/AccountType'
import { ParseJSONPropertyInObject } from '@/utils/ParseJSONPropertyInObject'
import EventBus, { BusEvent } from '@/utils/EventBus'

const props = defineProps({
  // Form input flashed back by the backend after a failed validation. Overlaid
  // onto the entity loaded from the API so typed values survive the reload.
  oldInput: {
    type: Object,
    default: () => ({}),
  },
})

const { result, loading } = useQuery(
  gql`
    query accountQuery($complianceNames: [ComplianceName!]!) {
      me {
        activeAccount {
          primaryLocation {
            state
          }
          __typename
          ...ActiveCompliancesOnAccount
          ...PrimaryBusinessEntityOnAccount
          ...UkBusinessEntityUmbrellaFormAccount
          ...FreelancerFrBusinessEntityFormAccount
        }
      }
    }
    ${PRIMARY_BUSINESS_ENTITY_ON_ACCOUNT_FRAGMENT}
    ${COMPLIANCE_RESULT_FRAGMENT}
    ${ACTIVE_COMPLIANCES_ON_ACCOUNT_FRAGMENT}
    ${UkBusinessEntityUmbrellaFormFragments.account}
    ${FreelancerFrBusinessEntityFormFragments.account}
  `,
  {
    complianceNames: businessEntityCompliances(),
  },
)

const activeAccount = computed(() => result?.value?.me?.activeAccount)
const _currentSelectedLocation = ref()
const currentSelectedLocation = computed({
  get() {
    return _currentSelectedLocation.value ?? activeAccount.value?.primaryLocation
  },
  set(val) {
    _currentSelectedLocation.value = val
  },
})
const primaryBusinessEntity = computed(() =>
  applyOldInputToBusinessEntity(
    businessEntityFromGraphql(activeAccount.value?.primaryBusinessEntity),
    props.oldInput,
  ),
)
const compliances = computed(
  () =>
    activeAccount.value?.compliances
      ?.filter((compliance) => compliance.isApplicable)
      ?.map((compliance) => ParseJSONPropertyInObject('data', compliance)) || [],
)

onMounted(() => {
  EventBus.off(BusEvent.SELECTED_PROFILE_LOCATION_CHANGED)
  EventBus.on(BusEvent.SELECTED_PROFILE_LOCATION_CHANGED, (location) => {
    currentSelectedLocation.value = location
  })
})
</script>
